import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { CustomAxios } from '../../services/api';
import LoginForm from "./login.form";
import Footers from "../frame/footers.component";
import Stomp from "stompjs";
import SockJS from "sockjs-client";
import { API_BASE_URL } from "../../services/apiConfig";
export default function Login() {   
  const queryParameters = new URLSearchParams(window.location.search)
  const code = queryParameters.get("code")

  useEffect(() => {          
    console.log("code = " , code);
  }, [code]); 

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh",backgroundColor: '#123758' }}>

    <div style={{ flex: 1, backgroundColor: '#123758' }}>
     
    <div 
      style={{
        width: '100%',
        backgroundImage: "url(asset/img/login_card_pattern.png)",
        backgroundSize: '55%', 
        backgroundPosition: '900px -500px',
        backgroundRepeat: 'no-repeat', 
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: '1',
        backgroundColor: '#123758'
      }}
    >
      <div
        style={{
          
          zIndex: '2',
        }}
      >
        <LoginForm/>
      </div>
      
    </div>


    </div>

    <div style={{ height: "75px"}}>
    <Footers />
      
    </div>

</div>
  );
}
